exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.attachable-widget-component {\n}\n.attachable-widget-component .notes-panel .ant-collapse-header,\n.attachable-widget-component .attachable-category .ant-collapse-header {\n  background-color: #98aebf !important;\n  color: white !important;\n}\n\n", ""]);

// exports
